var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var logreq = process.env.httpsendlog;
var unique_id = 1;

var HttpWrapper =
/*#__PURE__*/
function () {
  "use strict";

  function HttpWrapper(web3) {
    _classCallCheck(this, HttpWrapper);

    this.HttpProvider = web3.providers.HttpProvider;
  }

  _createClass(HttpWrapper, [{
    key: "send",
    value: function send(url, jsonRequestData, callback) {
      var maxlen = 120;
      jsonRequestData = jsonRequestData || {};
      var localid = unique_id++;

      if (logreq) {
        console.log("sending request:", localid, url, JSON.stringify(jsonRequestData).slice(0, maxlen));
      }

      var callback1 = function callback1(e, r) {
        if (e && ("" + e).indexOf("Invalid JSON RPC response") >= 0) {
          e = {
            error: "invalid-json"
          };
        }

        if (("" + r).indexOf("\"error\"") >= 0) {
          e = r;
          r = null;
        }

        if (!e && r && r.error) {
          e = r;
          r = null;
        }

        if (logreq) {
          console.log("got response:", localid, JSON.stringify(r).slice(0, maxlen), "err=", JSON.stringify(e).slice(0, maxlen));
        }

        callback(e, r);
      };

      var provider = new this.HttpProvider(url);
      var send = provider['sendAsync'] || provider['send'];
      send.bind(provider)(jsonRequestData, callback1);
    }
  }, {
    key: "sendPromise",
    value: function sendPromise(url, jsonRequestData) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.send(url, jsonRequestData, function (e, r) {
          if (e) return reject(e);
          return resolve(r);
        });
      });
    }
  }]);

  return HttpWrapper;
}();

module.exports = HttpWrapper;